import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import BlockIcon from '@mui/icons-material/Block';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';


import UserInfo from './UserInfo';
import Client from './Client';

import {styled} from "@mui/system";
import AllDevices from "./AllDevices";


function Devices(props) {
  //const [user, loading_user, error] = useAuthState(auth);
  const uid = sessionStorage.getItem("uid");
  const power_user = (sessionStorage.getItem("power_user")=="true");

  const history = useHistory();

  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState();
  const [selectedDeviceName, setSelectedDeviceName] = useState();

  const [openAdd, setOpenAdd] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [isAdmin, setIsAdmin] = useState(false);

  const [clientInfo, setClientInfo] = useState();

  /*
  const [flip, set] = useState(false)
  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    reset: true,
    reverse: flip,
    delay: 200,
    onRest: () => set(!flip),
  }) */

  const LinkButton = styled(Button)({
    textTransform: 'none',
  });

  useEffect(() => {
    setIsAdmin(sessionStorage.getItem("admin")=="true");
}, []);

if (!isAdmin)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <IconButton onClick={() => history.goBack()}>
                    <BlockIcon />
                </IconButton>
                Authorized user only...
              </Typography>
            </Box>
            </div>);
  }

const updateDevice = (deviceId) => {
    history.push(
        { pathname: '/update_device',
          state: {
              deviceId: deviceId,
          }
        });
}

const deleteDevice = () => {
  //console.log("Post start datetime:: " + moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"));
  //console.log("Post end datetime:: " + moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"));
}

const handleDelete = (id, name) => {
    setSelectedDevice(id);
    setSelectedDeviceName(name);
    setOpenDelete(true);
}

const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

const handleCloseAdd = () => {
    setOpenAdd(false);
  };

const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  return (
    <div className="container">  
            <Container maxWidth="lg" >              
                <Grid container spacing={2} sx={{pt: 14, pl:2, pr:2, pb:2}}>
                    <Grid xs={12}>
                      <AllDevices />
                    </Grid>
                </Grid>
            </Container>
    </div>
  );
}

export default Devices;
